const mountCallsStatus = item => {
    let jsonMounted = "";

    try {   
        if(item.length !== 0){
            // jsonMounted = "["
            item.map((todo, index) => {
                jsonMounted = jsonMounted+`${todo.idmidia}§${todo.telefone}`;
                if(index+1 !== item.length)
                    jsonMounted = jsonMounted+"¿"
            })
            // jsonMounted = jsonMounted+"]";
        }
    } catch (error) {
            
    }
    return jsonMounted;
}

export default mountCallsStatus;

// if(item.length !== 0){
//     jsonMounted = "["
//     item.map((todo, index) => {
//         jsonMounted = jsonMounted+'{"CHANNEL":'+todo.idmidia+',"PHONE":'+todo.telefone+'}';
//         if(index+1 !== item.length)
//             jsonMounted = jsonMounted+","
//     })
//     jsonMounted = jsonMounted+"]";
// }